<template>
  <div class="container">
    <div class="content-font">
      <h1>
        什么是优惠券？&nbsp;
      </h1>
      <p>
        优惠券指万顺叫车平台发行并认可的抵用现金券，在万顺叫车平台下单时使用。
      </p>
      <hr>
      <h1>
        优惠券有哪些类型？&nbsp;
      </h1>
      <p>
        万顺叫车平台发放的优惠券有折扣券、满减抵扣券、优惠最低消费、立减券等。&nbsp;
      </p>
      <hr>
      <h1>
        如何获取优惠券？&nbsp;
      </h1>
      <p>
        通过好友推荐，或参与平台活动可以获取。&nbsp;
      </p>
      <hr>
      <h1>
        优惠券怎么使用？&nbsp;
      </h1>
      <p>
        在万顺叫车打车付款时，可以选择使用优惠券，只需要满足优惠券的使用条件即可。&nbsp;
      </p>
      <hr>
      <h1>
        优惠券使用条件&nbsp;
      </h1>
      <p>
        1.优惠券不找零、不兑现，支付车费时使用；&nbsp;
      </p>
      <p>
        2.仅限在线支付时使用，每个订单只能使用一张优惠券；&nbsp;
      </p>
      <p>
        3.使用优惠券时，付款时间需要在优惠券有效期内；&nbsp;
      </p>
      <p>
        4.仅限用于抵扣按里程和时长计价部分的费用，不可抵扣车主输入的附加费用；&nbsp;
      </p>
      <p>
        5.只有满足优惠券使用条件的优惠券才能使用；&nbsp;
      </p>
      <hr>
      <div class="font-bottom">万顺叫车保留法律允许范围内的最终解释权。</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    mounted() {
    },
    methods: {},
  };
</script>
<style scoped lang="less">
  .font-bottom {
    text-align: center;
    font-size: 0.75rem;
    color: #666;
    padding-top: 0.5rem;
  }
</style>

